'use strict';

angular.module('mandaeApp')
  .config(function($stateProvider) {
    $stateProvider
      .state('finalizar-cadastro', {
        abstract: true,
        url: '/finalizar-cadastro',
        template: require('./finalizar-cadastro.html')
      })
    .state('gasto-mensal', {
        parent: 'finalizar-cadastro',
        url: '/gasto-mensal',
        template: require('./gasto-mensal/gasto-mensal.html'),
        controller: 'GastoMensalCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Finalizar Cadastro: Gasto Mensal'
        }
      })
      .state('endereco', {
        parent: 'finalizar-cadastro',
        url: '/endereco',
        template: require('./endereco/endereco.html'),
        controller: 'EnderecoCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Finalizar Cadastro: Endereço'
        }
      })
      .state('documento', {
        parent: 'finalizar-cadastro',
        url: '/documento',
        template: require('./documento/documento.html'),
        controller: 'DocumentoCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Finalizar Cadastro: Documentos'
        },
      });
  });
